import React, { useEffect } from 'react';
import HeroBanner from '../components/common/HeroBanner/HeroBanner';

const Pricing = () => {
  useEffect(() => {
    document.title = 'NEST | Pricing';
  }, []);
  return (
    <div>
      <HeroBanner 
        title="Car Rates Pricing" 
        breadcrumbs={['Pricing']}
      />
      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-md-7 heading-section text-center ftco-animate">
              <h2>Pricing Information Coming Soon</h2>
              <p>Contact us for a custom quote.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pricing;


